import { Applicant } from "types/application";
import { DocumentUploadView } from "./components/DocumentUploadView";
import { Button, ButtonSize } from "shared/components";
import { DocumentSection } from "./components/DocumentSection";
import { DocumentPDFViewer } from "./components/DocumentPDFViewer";

export const AdditionalDocumentsSlice = ({
  applicant
}: {
  applicant: Applicant;
}) => {
  return (
    <>
      <div className="h-full space-y-6 no-print">
        <div className="mb-4 flex items-center justify-between">
          <p className="text-xl font-bold text-content-1000">
            Additional documents
          </p>
          <Button
            size={ButtonSize.SM}
            onClick={(e) => {
              e.preventDefault();
              window.print();
            }}
          >
            Print report
          </Button>
        </div>
        <DocumentUploadView applicantId={applicant.id} />
        <DocumentSection applicantId={applicant.id} />
      </div>
      <DocumentPDFViewer applicantId={applicant.id} />
    </>
  );
};
